import Input from './Input'
import Button from './Button'
import useFormulario from '../hooks/useFormulario'

const UserForm = ({ submit }) => {
  const [formulario, handleChange, reset] = useFormulario({
    name: '',
    email: '',
    lastname: ''
  })
  const handleSubmit = (e) => {
    e.preventDefault()
    submit(formulario)
    reset()
  }
  return (
          <form onSubmit={handleSubmit}>
            <Input
              label="Nombre"
              name="name"
              value={formulario.name}
              onChange={handleChange}
              placeholder='Nombre'
              required
            />
            <Input
              label="Apellido"
              name="lastname"
              value={formulario.lastname}
              onChange={handleChange}
              placeholder='Apellido'
              required
            />
            <Input
              label="Correo"
              name="email"
              value={formulario.email}
              onChange={handleChange}
              placeholder='Correo'
              required
            />
            <p className='see'>*See in console</p>
            <Button>Enviar</Button>
          </form>
  )
}

export default UserForm
